// import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { AuthService } from '../_services/auth.service';
// import { AlertService } from '../_services/alert.service';
// import { HttpErrorResponse } from '@angular/common/http';
// import { AccountService } from '../_services/domainservice/account.service'
// import { SharedComponent } from '../../shared/shared.component';
// import { Injectable } from '@angular/core';
// import { ClientRegistration } from '../model/client.model';
// import { ProductService } from '../_services/domainservice/product.service'
// import { Account } from '../model/account.model';
// import { MenuService } from '../_services/domainservice/menu.service';
// import { Guid } from '../_helpers/guid';
// import { AttendanceDeviceService } from '../_services/domainservice/attendancedevice.service';
// import { AttendanceDevice } from '../model/attendancedevice.model';


// @Component({
//   templateUrl: 'login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent extends SharedComponent implements OnInit {
//   loginForm: FormGroup;
//   loading = false;
//   submitted = false;
//   returnUrl: string;
//   isPageLoaded = false;
//   client: ClientRegistration = new ClientRegistration;
//   clientRegistrationUId: string;
//   Devicelist: Array<AttendanceDevice>;
//   DeviceNamelist: string;
//   constructor(
//     private accountService: AccountService,
//     private formBuilder: FormBuilder,
//     private route: ActivatedRoute,
//     private router: Router,
//     private alertService: AlertService,
//     public authService: AuthService,
//     private renderer: Renderer2,
//     private productService: ProductService,
//     readonly menuService: MenuService,
//     private attendancedeviceService: AttendanceDeviceService

//   ) {
//     super();
//     this.route.queryParams.subscribe(params => {
//       this.returnUrl = params['returnUrl'];
//     });

//   }

//   ngOnInit() {

//     //email: ['john@pixinvent.com', Validators.required],
//     //  password: ['password@123', Validators.required],
//     //email: ['ganapathy@abgtechnologys.com', Validators.required],
//     //password: ['ganbapathym110#', Validators.required],
//     this.loginForm = this.formBuilder.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: false
//     });
//     // Remember Me
//     if (localStorage.getItem('remember')) {
//       this.renderer.removeClass(document.body, 'bg-full-screen-image');
//       localStorage.removeItem('currentLayoutStyle');
//       //this.router.navigate(['/dashboard/gym']);
//     } else if (localStorage.getItem('currentUser')) {
//       // Force logout on login if not remember me
//       this.authService.doLogout();
//       this.isPageLoaded = true;
//     } else {
//       this.isPageLoaded = true;
//     }
//   }

//   // convenience getter for easy access to form fields
//   get f() {
//     return this.loginForm.controls;
//   }

//   getpasswordpage() {
//     this.router.navigate(['/login/forgotpassword']);
//   }

//   tryLogin() {
//     this.submitted = true;

//     // stop here if form is invalid
//     if (this.loginForm.invalid) {
//       return;
//     }
//     const value = {
//       email: this.f.email.value,
//       password: this.f.password.value
//     };

//     this.accountService.getAccountLogin(this.getBase64Encode(value.email), this.getBase64Encode(value.password)).subscribe((data): void => {
//       // this.appservice.spinner.next(false);
//       if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
//         localStorage.setItem('remember', 'true');
//       } else {
//         localStorage.removeItem('remember');
//       }
//       this.setUserInStorage(data);
//       this.setCurrentClientUId(data['clientRegistrationUId']);
//       this.setCurrentRoleBasedlogedin(data['roleBasedLogedin'] ? data['roleBasedLogedin'] : Guid.empty);
//       this.setCurrentloggedinUId(data['loggedInUId']);
//       this.setCurrentEmailId(data['mobileNumber']);


//       this.productService.getProduct(data['clientRegistration'].productUId).subscribe((product): void => {
//         this.setProductInStorage(product);
//         this.setCurrentProductUId(product['productUId'])
//         //if (JSON.parse(localStorage.getItem('currentProduct')).productUId === '00000010-0000-0000-0000-000000000000') {

//         //  this.menuService.getMenu().subscribe((menudata): void => {
//         //    this.setMenuInStorage(menudata);
//         //  },
//         //    (error: HttpErrorResponse): void => {
//         //      console.log(error);
//         //      this.alertService.error(error.message);
//         //    }
//         //  );
//         //} else {
//         this.menuService.getMenuProduct(JSON.parse(localStorage.getItem('currentProduct')).productUId, data['roleBasedLogedin']).subscribe((menudata): void => {
//           //this.setMenuInStorage(menudata);
//           this.menuService.setmenu(menudata);
//           this.redirectLogin(menudata);
//           this.attendancedeviceService.getAttendanceDevice(data['clientRegistrationUId']).subscribe((getdevicedata): void => {
//             this.Devicelist = getdevicedata;
//             this.DeviceNamelist = this.Devicelist.filter(o => o.attendanceDeviceName).map(o => o.attendanceDeviceName).join('|').toString();
//             this.setCurrentDeviceID(this.DeviceNamelist);
//           },
//             (error: HttpErrorResponse): void => {
//               console.log(error);
//               this.alertService.error(error.message);
//             }
//           );
//           },
//             (error: HttpErrorResponse): void => {
//               console.log(error);
//               this.alertService.error(error.message);
//             }
//           );
//         //}
//       },

//         (error: HttpErrorResponse): void => {
//           // console.log(error);
//           // this.appservice.spinner.next(false);
//           this.submitted = false;
//           this.alertService.error(error.message);
//         });



//     },
//       (error: HttpErrorResponse): void => {
//         // console.log(error);
//         // this.appservice.spinner.next(false);
//         this.submitted = false;
//         this.alertService.error(error.error.detail);
//       }
//     );


//     //this.authService.doLogin(value).then(
//     //  res => {
//     //    if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
//     //      localStorage.setItem('remember', 'true');
//     //    } else {
//     //      localStorage.removeItem('remember');
//     //    }
//     //    this.setUserInStorage(res);
//     //    localStorage.removeItem('currentLayoutStyle');
//     //    let returnUrl = '/dashboard/sales';
//     //    if (this.returnUrl) {
//     //      returnUrl = this.returnUrl;
//     //    }
//     //    this.router.navigate([returnUrl]);
//     //  },
//     //  err => {
//     //    this.submitted = false;
//     //    this.alertService.error(err.message);
//     //  }
//     //);
//   }
//   addCheckbox(event) {
//     const toggle = document.getElementById('icheckbox');
//     if (event.currentTarget.className === 'icheckbox_square-blue') {
//       this.renderer.addClass(toggle, 'checked');
//     } else if (event.currentTarget.className === 'icheckbox_square-blue checked') {
//       this.renderer.removeClass(toggle, 'checked');
//     }
//   }
//   setUserInStorage(user) {
//     if (user.name) {
//       localStorage.setItem('currentUser', JSON.stringify(user));
//     } else {
//       localStorage.setItem('currentUser', JSON.stringify(user));
//     }
//   }
//   setProductInStorage(product) {
//     if (product.productUId) {
//       localStorage.setItem('currentProduct', JSON.stringify(product));
//     }
//     else {
//       localStorage.setItem('currentProduct', JSON.stringify(product));
//     }
//   }

//   setCurrentProductUId(CurrentProductUId) {
//     localStorage.setItem('CurrentProductUId', CurrentProductUId);
//   }
//   setCurrentClientUId(CurrentClientUId) {
//     localStorage.setItem('CurrentClientUId', CurrentClientUId);
//   }
//   setCurrentRoleBasedlogedin(CurrentRoleBasedlogedin) {
//     localStorage.setItem('CurrentRoleBasedlogedin', CurrentRoleBasedlogedin);
//   }
//   setCurrentloggedinUId(CurrentloggedInUId) {
//     localStorage.setItem('CurrentloggedInUId', CurrentloggedInUId);
//   }
//   setCurrentDeviceID(CurrentDeviceID) {
//     localStorage.setItem('CurrentDeviceID', CurrentDeviceID);
//   }
//   setCurrentEmailId(EmailId)
//   {
//     localStorage.setItem('EmailId', EmailId);
//   }

//   //setMenuInStorage(Menus) {
//   //  localStorage.setItem('currentMenus', JSON.stringify(Menus));
//   //  this.redirectLogin(Menus);
//   //}

//   redirectLogin(UserDetails){
//     localStorage.removeItem('currentLayoutStyle');
//     UserDetails=UserDetails.sort(function (a, b) {
//       return a.displayOrder - b.displayOrder;
//     });
//     let returnUrl = UserDetails[0].page;// '/dashboard/gym';
//     if (this.returnUrl) {
//       returnUrl = this.returnUrl;
//     }
//     //this.alertService.success("Welcome!");
//     this.router.navigate([returnUrl]);
//   }


// }







// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { LoginService } from '../_services/domainservice/login.service' // adjust path to your AccountService
// import { ClientService } from '../_services/domainservice/Client.service';

// /**
//  * LOGIN COMPONENT
//  * Written to match the existing login.component.html bindings exactly:
//  *   isPageLoaded, loginForm (email/password/rememberMe), submitted, showPassword,
//  *   f getter, tryLogin(), addCheckbox($event).
//  *
//  * It calls AccountService.login(email, password, rememberMe) which should POST to the
//  * backend /api/auth/login and return { accessToken, refreshToken, user }.
//  * A ready-to-paste login() service method is provided at the bottom of this file.
//  *
//  * NOTE: this is a fresh implementation (your original login.component.ts was never provided).
//  * Verify the service path, the post-login route, and token storage against your app.
//  */
// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {

//   loginForm!: FormGroup;
//   submitted = false;      // drives the button spinner (*ngIf="submitted")
//   isPageLoaded = false;   // root *ngIf on the template
//   showPassword = false;   // password visibility toggle
//   errorMessage = '';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });
//     this.isPageLoaded = true;
//   }

//   /** Convenience accessor used by the template as f.email / f.password. */
//   get f() { return this.loginForm.controls; }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false; // release the spinner so validation messages show
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         //console.log(res);
//         // Persist tokens (adjust to your existing storage/session strategy).
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('refreshToken', res.refreshToken);
//           localStorage.setItem('user', JSON.stringify(res.user || {}));
//         }
//         this.submitted = false;
//         this.clientService.getClient().subscribe((data): void => {
//           let emailExists = false;

//           for (let i = 0; i < data.length; i++) {
//             if (res.user.email === data[i].emailAddress) {
//               emailExists = true;
//               break;
//             }
//           }

//           if (emailExists) {
//             this.router.navigate(['/dashboard']);
//           } else {
//             this.router.navigate(['/clientinfo']);
//           }
//         });

//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             // The backend returns 401 with code REQUIRES_2FA + challengeToken when 2FA is on.
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   setUserInStorage(user) {
//       if (user.name) {
//         localStorage.setItem('currentUser', JSON.stringify(user));
//       } else {
//         localStorage.setItem('currentUser', JSON.stringify(user));
//       }
//     }
//     setProductInStorage(product) {
//       if (product.productUId) {
//         localStorage.setItem('currentProduct', JSON.stringify(product));
//       }
//       else {
//         localStorage.setItem('currentProduct', JSON.stringify(product));
//       }
//     }

//     setCurrentProductUId(CurrentProductUId) {
//       localStorage.setItem('CurrentProductUId', CurrentProductUId);
//     }
//     setCurrentClientUId(CurrentClientUId) {
//       localStorage.setItem('CurrentClientUId', CurrentClientUId);
//     }
//     setCurrentRoleBasedlogedin(CurrentRoleBasedlogedin) {
//       localStorage.setItem('CurrentRoleBasedlogedin', CurrentRoleBasedlogedin);
//     }
//     setCurrentloggedinUId(CurrentloggedInUId) {
//       localStorage.setItem('CurrentloggedInUId', CurrentloggedInUId);
//     }
//     setCurrentDeviceID(CurrentDeviceID) {
//       localStorage.setItem('CurrentDeviceID', CurrentDeviceID);
//     }
//     setCurrentEmailId(EmailId)
//     {
//       localStorage.setItem('EmailId', EmailId);
//     }


//   /**
//    * Remember-me: toggles the reactive-form control and the legacy iCheck visual state.
//    * The template's #icheckbox div gets the .checked class (styled in login.component.css).
//    */
//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);

//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }



// import { Component, OnInit, Optional } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';

// import { LoginService } from '../_services/domainservice/login.service';
// import { ClientService } from '../_services/domainservice/Client.service';
// // These three existed in the OLD (working) design and drive the logo/company/menu.
// // They live in the same domainservice folder. If a filename differs, fix the path.
// import { ProductService } from '../_services/domainservice/product.service';
// import { MenuService } from '../_services/domainservice/menu.service';
// import { AttendanceDeviceService } from '../_services/domainservice/attendancedevice.service';

// const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

// /**
//  * LOGIN COMPONENT — complete.
//  * UI bindings unchanged (isPageLoaded, loginForm, submitted, showPassword, f,
//  * tryLogin, addCheckbox). Restores the OLD design's full post-login chain:
//  * authenticate -> resolve client -> store rich user/product/client context ->
//  * load menu (setmenu) -> load attendance devices -> redirect by menu order.
//  * That chain is what makes the logo, company name, profile and menu appear.
//  */
// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {

//   loginForm!: FormGroup;
//   submitted = false;
//   isPageLoaded = false;
//   showPassword = false;
//   errorMessage = '';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//     private readonly productService: ProductService,
//     private readonly menuService: MenuService,
//     // Optional so a missing provider never crashes login.
//     @Optional() private readonly attendancedeviceService: AttendanceDeviceService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });

//     if (localStorage.getItem('remember')) {
//       localStorage.removeItem('currentLayoutStyle');
//     }
//     this.isPageLoaded = true;
//   }

//   get f() { return this.loginForm.controls; }

//   /** Return the first non-empty value among the given keys. */
//   private pick(source: any, keys: string[]): any {
//     if (!source) { return undefined; }
//     for (const k of keys) {
//       const v = source[k];
//       if (v !== undefined && v !== null && v !== '') { return v; }
//     }
//     return undefined;
//   }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false;
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         // Remember-me (old parity)
//         if (rememberMe) { localStorage.setItem('remember', 'true'); }
//         else { localStorage.removeItem('remember'); }
//         localStorage.removeItem('currentLayoutStyle');

//         // Tokens (new design)
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('refreshToken', res.refreshToken);
//           localStorage.setItem('user', JSON.stringify(res.user || {}));
//         }

//         this.loadClientContext(res);
//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   /**
//    * Resolve the client record, store the context the shell reads, then load
//    * product + menu (+ attendance) and redirect.
//    *   matched client  -> registered: full load + redirect
//    *   no match        -> new account: /clientinfo to register the client first
//    */
//   private loadClientContext(res: any): void {
//     this.clientService.getClient().subscribe({
//       next: (clients: any[]) => {
//         const list = clients || [];
//         const email = this.pick(res?.user, ['email', 'emailAddress', 'Email']);
//         const matched = list.find(c =>
//           this.pick(c, ['emailAddress', 'email', 'EmailAddress']) === email);

//         // Brand-new account -> go register the client.
//         if (!matched) {
//           this.submitted = false;
//           this.router.navigate(['/clientinfo']);
//           return;
//         }

//         // Resolve identifiers from the client record (login response is slim),
//         // trying the common name variants so naming differences don't break it.
//         const clientRegistrationUId =
//           this.pick(matched, ['clientRegistrationUId', 'ClientRegistrationUId', 'clientRegistrationUID']) ??
//           this.pick(res?.user, ['clientRegistrationUId', 'ClientRegistrationUId']);

//         const roleBasedLogedin =
//           this.pick(res?.user, ['roleBasedLogedin', 'RoleBasedLogedin', 'roleBasedLoggedIn']) ??
//           this.pick(matched, ['roleBasedLogedin', 'RoleBasedLogedin']) ??
//           GUID_EMPTY;

//         const productUId =
//           this.pick(matched, ['productUId', 'ProductUId', 'productUID']) ??
//           this.pick(matched?.clientRegistration, ['productUId', 'ProductUId']) ??
//           this.pick(res?.user, ['productUId', 'ProductUId']);

//         // Display fields for the header (logo / company / profile). We spread the
//         // whole matched record so whatever key names the header uses are present,
//         // and also normalise the common ones.
//         const currentUser = {
//           ...(res?.user || {}),
//           ...matched,
//           logo: this.pick(matched, ['logo', 'logoUrl', 'companyLogo', 'logoPath', 'clientLogo']),
//           companyName: this.pick(matched, ['companyName', 'CompanyName', 'company', 'clientName']),
//           profileName: this.pick(matched, ['profileName', 'ProfileName', 'contactPerson', 'name'])
//         };

//         this.setUserInStorage(currentUser);                               // 'currentUser'
//         localStorage.setItem('currentClient', JSON.stringify(matched));   // header logo/company source
//         this.setCurrentClientUId(clientRegistrationUId);
//         this.setCurrentRoleBasedlogedin(roleBasedLogedin);
//         this.setCurrentloggedinUId(this.pick(res?.user, ['loggedInUId', 'id', 'userId']));
//         this.setCurrentEmailId(this.pick(matched, ['mobileNumber', 'emailAddress']) ?? email);

//         if (!productUId) {
//           // No product to scope the menu -> land on dashboard rather than blocking.
//           this.submitted = false;
//           this.router.navigate(['/dashboard']);
//           return;
//         }

//         // -- Product ------------------------------------------------
//         this.productService.getProduct(productUId).subscribe({
//           next: (product: any) => {
//             this.setProductInStorage(product);                            // 'currentProduct'
//             this.setCurrentProductUId(this.pick(product, ['productUId', 'ProductUId']) ?? productUId);

//             // -- Menu (renders the sidebar) --------------------------
//             this.menuService.getMenuProduct(
//               this.pick(product, ['productUId', 'ProductUId']) ?? productUId,
//               roleBasedLogedin
//             ).subscribe({
//               next: (menudata: any[]) => {
//                 this.menuService.setmenu(menudata);

//                 // -- Attendance devices (optional) -----------------
//                 if (this.attendancedeviceService && clientRegistrationUId) {
//                   this.attendancedeviceService.getAttendanceDevice(clientRegistrationUId).subscribe({
//                     next: (devices: any[]) => {
//                       const names = (devices || [])
//                         .filter(o => o.attendanceDeviceName)
//                         .map(o => o.attendanceDeviceName)
//                         .join('|');
//                       this.setCurrentDeviceID(names);
//                     },
//                     error: (e: HttpErrorResponse) => console.log(e)
//                   });
//                 }

//                 this.submitted = false;
//                 this.redirectLogin(menudata);
//               },
//               error: (e: HttpErrorResponse) => {
//                 this.submitted = false;
//                 console.log(e);
//                 this.errorMessage = 'Signed in, but the menu could not be loaded.';
//               }
//             });
//           },
//           error: (e: HttpErrorResponse) => {
//             this.submitted = false;
//             console.log(e);
//             this.errorMessage = 'Signed in, but the product could not be loaded.';
//           }
//         });
//       },
//       error: (e: HttpErrorResponse) => {
//         this.submitted = false;
//         console.log(e);
//         this.errorMessage = 'Signed in, but client details could not be loaded.';
//       }
//     });
//   }

//   /** Old-design redirect: sort menu by displayOrder, navigate to the first page. */
//   private redirectLogin(menu: any[]): void {
//     localStorage.removeItem('currentLayoutStyle');
//     const sorted = (menu || []).slice().sort((a, b) => a.displayOrder - b.displayOrder);
//     const target = sorted.length && sorted[0].page ? sorted[0].page : '/dashboard';
//     this.router.navigate([target]);
//   }

//   // -- Storage setters (existed in your new file, now actually called) --
//   setUserInStorage(user: any) { localStorage.setItem('currentUser', JSON.stringify(user)); }
//   setProductInStorage(product: any) { localStorage.setItem('currentProduct', JSON.stringify(product)); }
//   setCurrentProductUId(v: any) { localStorage.setItem('CurrentProductUId', v); }
//   setCurrentClientUId(v: any) { localStorage.setItem('CurrentClientUId', v); }
//   setCurrentRoleBasedlogedin(v: any) { localStorage.setItem('CurrentRoleBasedlogedin', v); }
//   setCurrentloggedinUId(v: any) { localStorage.setItem('CurrentloggedInUId', v); }
//   setCurrentDeviceID(v: any) { localStorage.setItem('CurrentDeviceID', v); }
//   setCurrentEmailId(v: any) { localStorage.setItem('EmailId', v); }

//   /** Remember-me + legacy iCheck visual toggle. */
//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);
//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }




// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { LoginService } from '../_services/domainservice/login.service';
// import { ClientService } from '../_services/domainservice/Client.service';

// /**
//  * LOGIN COMPONENT
//  * Post-login routing fix: the AuthGuard / app reads `currentUser` from localStorage
//  * (see Clientinfo.ts), but the previous version only stored `user`, so the guard
//  * bounced every navigation back to /login?returnUrl=... . We now persist `currentUser`
//  * and honour the returnUrl.
//  */
// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {

//   loginForm!: FormGroup;
//   submitted = false;
//   isPageLoaded = false;
//   showPassword = false;
//   errorMessage = '';
//   returnUrl = '/dashboard';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly route: ActivatedRoute,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });
//     // Where the guard wanted to send us before it bounced to /login.
//     this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
//     this.isPageLoaded = true;
//   }

//   get f() { return this.loginForm.controls; }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false;
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         // --- Persist tokens ---
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('token', res.accessToken);      // some interceptors read 'token'
//           localStorage.setItem('refreshToken', res.refreshToken || '');
//         }

//         const user = res?.user || {};

//         // --- Persist user under BOTH keys ---
//         // `currentUser` is the key the AuthGuard and the feature pages actually read.
//         //localStorage.setItem('user', JSON.stringify(user));
//         //this.setUserInStorage(user);

//         // Seed the tenant / product context the app expects, when present.
//         // if (user.product) { this.setProductInStorage(user.product); }
//         // if (user.productUId) { this.setCurrentProductUId(user.productUId); }
//         // if (user.clientRegistrationUId) { this.setCurrentClientUId(user.clientRegistrationUId); }
//         // if (user.roleBasedLogedin) { this.setCurrentRoleBasedlogedin(user.roleBasedLogedin); }
//         // if (user.loggedInUId) { this.setCurrentloggedinUId(user.loggedInUId); }
//         // if (user.email) { this.setCurrentEmailId(user.email); }

//         this.submitted = false;

//         // Decide destination: existing tenant -> returnUrl (default /dashboard),
//         // brand-new user with no client registration -> onboarding.
//         this.clientService.getClient().subscribe(
//           (data: any[]): void => {

//             const emailExists = (data || []).some(d => d.emailAddress === user.email);
//             // localStorage.setItem('user', JSON.stringify(data));
//             // this.setUserInStorage(data);
//             // if (emailExists) {
//               //localStorage.setItem('user', JSON.stringify(data));
//               this.setUserInStorage(data);
//               this.router.navigateByUrl(this.returnUrl);

//             // } else {
//             //   this.router.navigate(['/clientinfo']);
//             // }
//           },
//           (): void => {
//             // If the client lookup fails, still let the user in.
//             this.router.navigateByUrl(this.returnUrl);
//           }
//         );
//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   setUserInStorage(user) {
//     if (user.name) {
//           localStorage.setItem('currentUser', JSON.stringify(user));
//         } else {
//           localStorage.setItem('currentUser', JSON.stringify(user));
//         }
//   }
//   setProductInStorage(product: any) {
//     localStorage.setItem('currentProduct', JSON.stringify(product));
//   }
//   setCurrentProductUId(CurrentProductUId: any) {
//     localStorage.setItem('CurrentProductUId', CurrentProductUId);
//   }
//   setCurrentClientUId(CurrentClientUId: any) {
//     localStorage.setItem('CurrentClientUId', CurrentClientUId);
//   }
//   setCurrentRoleBasedlogedin(CurrentRoleBasedlogedin: any) {
//     localStorage.setItem('CurrentRoleBasedlogedin', CurrentRoleBasedlogedin);
//   }
//   setCurrentloggedinUId(CurrentloggedInUId: any) {
//     localStorage.setItem('CurrentloggedInUId', CurrentloggedInUId);
//   }
//   setCurrentDeviceID(CurrentDeviceID: any) {
//     localStorage.setItem('CurrentDeviceID', CurrentDeviceID);
//   }
//   setCurrentEmailId(EmailId: any) {
//     localStorage.setItem('EmailId', EmailId);
//   }

//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);
//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }







// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { LoginService } from '../_services/domainservice/login.service';
// import { ClientService } from '../_services/domainservice/Client.service';

// /**
//  * LOGIN COMPONENT
//  *
//  * Fix: the Client ID (ClientRegistrationUId = tenant key) was never persisted after login,
//  * so the vertical menu / dashboard had no tenant context and rendered blank.
//  *
//  * Client ID resolution order:
//  *   1) res.user.clientRegistrationUId  — if the backend already returns it (preferred; secure).
//  *   2) otherwise, match the ClientRegistration row by the signed-in email (emailAddress === user.email)
//  *      and take its clientRegistrationUId.
//  *
//  * Whatever resolves is stored under the keys the rest of the app reads:
//  *   currentUser (the user object, NOT the client array), currentClient, CurrentClientUId,
//  *   CurrentProductUId, EmailId.
//  */
// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {

//   loginForm!: FormGroup;
//   submitted = false;
//   isPageLoaded = false;
//   showPassword = false;
//   errorMessage = '';
//   returnUrl = '/dashboard';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly route: ActivatedRoute,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });
//     this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
//     this.isPageLoaded = true;
//   }

//   get f() { return this.loginForm.controls; }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false;
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         // --- Persist tokens ---
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('token', res.accessToken);
//           localStorage.setItem('refreshToken', res.refreshToken || '');
//         }

//         const user = res?.user || {};
//         this.submitted = false;

//         // If the backend already returned the tenant, use it directly — no need to
//         // fetch the whole client list (faster + respects tenant isolation).
//          if (user.clientRegistrationUId) {
//         //   this.applyContextAndRoute(user, null);
//         //   return;
//         }
//         this.setCurrentProductUId(user.productId);
//         // Otherwise resolve the Client ID from ClientRegistration by matching the email.
//         this.clientService.getClient(user.clientRegistrationUId.toString()).subscribe(
//           (data: any): void => {
//             localStorage.setItem('currentUser', JSON.stringify(data));
//             localStorage.setItem('companyName', data.companyName);

//             console.log(localStorage.getItem('companyName'));
//             this.setUserInStorage(data);
//             //this.setCurrentProductUId(user.primaryProductId);
//             const email = (user.email || '').toString().trim().toLowerCase();
//             const matched = (data || []).find(
//               c => (c.emailAddress || '').toString().trim().toLowerCase() === email
//             ) || null;
//             this.router.navigateByUrl(this.returnUrl);
//             //this.applyContextAndRoute(user, matched);
//           },
//           (): void => {
//             // Client lookup failed (e.g. token not yet attached) — still seed what we have.
//             //this.applyContextAndRoute(user, null);
//           }
//         );
//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   /**
//    * Merges the tenant context onto the user object, persists everything the shell/menu/
//    * dashboard read, and routes: dashboard when a Client ID exists, onboarding when it doesn't.
//    */
//   private applyContextAndRoute(user: any, client: any | null): void {
//     const clientId = user.clientRegistrationUId || client?.clientRegistrationUId || null;
//     const productId = user.productUId || client?.productUId || null;

//     // The object feature pages actually consume — carries the resolved tenant + branding.
//     const sessionUser = {
//       ...user,
//       clientRegistrationUId: clientId,
//       productUId: productId,
//       companyName: client?.companyName ?? user.companyName ?? null,
//       logo: client?.logo ?? user.logo ?? null
//     };

//     //this.setUserInStorage(sessionUser);
//     if (client) { this.setClientInStorage(client); }
//     if (clientId) { this.setCurrentClientUId(clientId); }
//     if (user.PrimaryProductId) { this.setCurrentProductUId(productId); }
//     if (user.email) { this.setCurrentEmailId(user.email); }
//     if (user.roleBasedLogedin) { this.setCurrentRoleBasedlogedin(user.roleBasedLogedin); }
//     if (user.loggedInUId) { this.setCurrentloggedinUId(user.loggedInUId); }

//     if (clientId) {
//       // Tenant resolved -> load the client-specific dashboard + vertical menu.
//       this.router.navigateByUrl(this.returnUrl);
//     } else {
//       // No organization for this user yet -> send them to complete client registration.
//       this.router.navigateByUrl(this.returnUrl);
//       //is.router.navigate(['/clientinfo']);
//     }
//   }

//   // ---- storage helpers ----
//   setUserInStorage(data) {
//     // Store under BOTH keys: the guard/feature pages read 'currentUser'; some read 'user'.
//     //localStorage.setItem('user', JSON.stringify(data));
//     localStorage.setItem('currentUser', JSON.stringify(data));
//     localStorage.setItem('companyName', data.companyName);
//   }
//   setClientInStorage(client: any) {
//     localStorage.setItem('currentClient', JSON.stringify(client));
//   }
//   setProductInStorage(product: any) {
//     localStorage.setItem('currentProduct', JSON.stringify(product));
//   }
//   setCurrentProductUId(CurrentProductUId: any) {
//     localStorage.setItem('CurrentProductUId', CurrentProductUId);
//   }
//   setCurrentClientUId(CurrentClientUId: any) {
//     localStorage.setItem('CurrentClientUId', CurrentClientUId);
//   }
//   setCurrentRoleBasedlogedin(CurrentRoleBasedlogedin: any) {
//     localStorage.setItem('CurrentRoleBasedlogedin', CurrentRoleBasedlogedin);
//   }
//   setCurrentloggedinUId(CurrentloggedInUId: any) {
//     localStorage.setItem('CurrentloggedInUId', CurrentloggedInUId);
//   }
//   setCurrentDeviceID(CurrentDeviceID: any) {
//     localStorage.setItem('CurrentDeviceID', CurrentDeviceID);
//   }
//   setCurrentEmailId(EmailId: any) {
//     localStorage.setItem('EmailId', EmailId);
//   }

//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);
//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }






// import { Component, Injectable, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { LoginService } from '../_services/domainservice/login.service';
// import { ClientService } from '../_services/domainservice/Client.service';
// import { BehaviorSubject } from 'rxjs';

// export interface SessionData {
//   accessToken: string;
//   refreshToken: string;
//   userId: string | null;
//   email: string | null;
//   role: string | null;
//   userGroupUgid: string | null;
//   permissions: string[];
//   clientRegistrationUId: string | null;   // tenant
//   productUId: string | null;              // drives menus / dashboard
//   companyName: string | null;
//   companyLogo: string | null;
// }

// const STORAGE_KEY = 'kg.session';

// @Injectable({ providedIn: 'root' })

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {
//   private readonly _session$ = new BehaviorSubject<SessionData | null>(this.load());
//   readonly session$ = this._session$.asObservable();


//   loginForm!: FormGroup;
//   submitted = false;
//   isPageLoaded = false;
//   showPassword = false;
//   errorMessage = '';
//   returnUrl = '/dashboard';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly route: ActivatedRoute,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });
//     this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
//     this.isPageLoaded = true;
//   }

//   get f() { return this.loginForm.controls; }
//   set(data: SessionData): void {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
//     this._session$.next(data);
//   }

//   /** Update a few fields without replacing the whole object (e.g. after loading company info). */
//   patch(partial: Partial<SessionData>): void {
//     const merged = { ...(this.current ?? {} as SessionData), ...partial } as SessionData;
//     this.set(merged);
//   }

//   get current(): SessionData | null {
//     return this._session$.value;
//   }

//   // Convenience getters every page can use.
//   get token(): string | null { return this.current?.accessToken ?? null; }
//   get clientRegistrationUId(): string | null { return this.current?.clientRegistrationUId ?? null; }
//   get productUId(): string | null { return this.current?.productUId ?? null; }
//   get companyName(): string | null { return this.current?.companyName ?? null; }
//   get companyLogo(): string | null { return this.current?.companyLogo ?? null; }
//   get email(): string | null { return this.current?.email ?? null; }
//   get role(): string | null { return this.current?.role ?? null; }

//   isLoggedIn(): boolean { return !!this.current?.accessToken; }

//   clear(): void {
//     localStorage.removeItem(STORAGE_KEY);
//     this._session$.next(null);
//   }

//   private load(): SessionData | null {
//     try {
//       const raw = localStorage.getItem(STORAGE_KEY);
//       return raw ? JSON.parse(raw) as SessionData : null;
//     } catch {
//       return null;
//     }
//   }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false;
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('token', res.accessToken);
//           localStorage.setItem('refreshToken', res.refreshToken || '');
//         }

//         const user = res?.user || {};
//         this.submitted = false;

//         const clientId = user.clientRegistrationUId || null;

//         // No tenant on the account yet -> onboarding.
//         if (!clientId) {
//           this.setUserInStorage(user);
//           this.router.navigate(['/clientinfo']);
//           return;
//         }

//         // Load this tenant's ClientRegistration record.
//         this.clientService.getClient(clientId.toString()).subscribe({
//           next: (data: any) => {
//             // *** KEY FIX ***  getClient may return a single object OR an array with one row.
//             // Normalise to a single client object; if it's an array, take the row whose id
//             // matches (fallback to the first element).
//             let client: any = null;
//             if (Array.isArray(data)) {
//               const idKey = clientId.toString().toLowerCase();
//               client = data.find(c => (c?.clientRegistrationUId || '').toString().toLowerCase() === idKey)
//                 || data[0] || null;
//             } else {
//               client = data || null;
//             }

//             this.storeSessionAndRoute(user, clientId, client);
//           },
//           error: () => {
//             // Lookup failed (token/interceptor issue) — still let them in with the id we have.
//             this.storeSessionAndRoute(user, clientId, null);
//           }
//         });
//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   private storeSessionAndRoute(user: any, clientId: any, client: any | null): void {
//     const companyName = client?.companyName ?? null;
//     const logo = client?.logo ?? null;
//     const productId = user.productUId ?? client?.productUId ?? null;

//     // currentUser is the USER object with branding merged in — NOT the raw array/response.
//     const sessionUser = {
//       ...user,
//       clientRegistrationUId: clientId,
//       productUId: productId,
//       companyName,
//       logo
//     };

//     this.setUserInStorage(sessionUser);
//     if (client) { this.setClientInStorage(client); }        // full ClientRegistration row
//     this.setCurrentClientUId(clientId);
//     if (productId) { this.setCurrentProductUId(productId); }
//     if (companyName) { localStorage.setItem('CompanyName', companyName); }
//     if (logo) { localStorage.setItem('CompanyLogo', logo); }
//     if (user.email) { this.setCurrentEmailId(user.email); }

//     console.log('[login] clientId=', clientId, ' companyName=', companyName);  // remove once verified

//     this.router.navigateByUrl(this.returnUrl);
//   }

//   // ---- storage helpers ----
//   setUserInStorage(data: any) {
//     localStorage.setItem('user', JSON.stringify(data));
//     localStorage.setItem('currentUser', JSON.stringify(data));
//   }
//   setClientInStorage(client: any) { localStorage.setItem('currentClient', JSON.stringify(client)); }
//   setProductInStorage(product: any) { localStorage.setItem('currentProduct', JSON.stringify(product)); }
//   setCurrentProductUId(v: any) { localStorage.setItem('CurrentProductUId', v); }
//   setCurrentClientUId(v: any) { localStorage.setItem('CurrentClientUId', v); }
//   setCurrentRoleBasedlogedin(v: any) { localStorage.setItem('CurrentRoleBasedlogedin', v); }
//   setCurrentloggedinUId(v: any) { localStorage.setItem('CurrentloggedInUId', v); }
//   setCurrentDeviceID(v: any) { localStorage.setItem('CurrentDeviceID', v); }
//   setCurrentEmailId(v: any) { localStorage.setItem('EmailId', v); }

//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);
//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }



// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { LoginService } from '../_services/domainservice/login.service';
// import { ClientService } from '../_services/domainservice/Client.service';

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent implements OnInit {

//   loginForm!: FormGroup;
//   submitted = false;
//   isPageLoaded = false;
//   showPassword = false;
//   errorMessage = '';
//   returnUrl = '/dashboard';

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly route: ActivatedRoute,
//     private readonly accountService: LoginService,
//     private readonly clientService: ClientService,
//   ) { }

//   ngOnInit(): void {
//     this.loginForm = this.fb.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: [false]
//     });
//     this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
//     this.isPageLoaded = true;
//   }

//   get f() { return this.loginForm.controls; }

//   tryLogin(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.loginForm.invalid) {
//       this.submitted = false;
//       return;
//     }

//     const { email, password, rememberMe } = this.loginForm.value;

//     this.accountService.login(email, password, rememberMe).subscribe({
//       next: (res: any) => {
//         if (res?.accessToken) {
//           localStorage.setItem('accessToken', res.accessToken);
//           localStorage.setItem('token', res.accessToken);
//           localStorage.setItem('refreshToken', res.refreshToken || '');
//         }

//         const user = res?.user || {};
//         this.submitted = false;

//         const clientId = user.clientRegistrationUId || null;

//         // No tenant on the account yet -> onboarding.
//         if (!clientId) {
//           this.setUserInStorage(user);
//           this.router.navigate(['/clientinfo']);
//           return;
//         }

//         // Load this tenant's ClientRegistration record.
//         this.clientService.getClient(clientId.toString()).subscribe({
//           next: (data: any) => {
//             // *** KEY FIX ***  getClient may return a single object OR an array with one row.
//             // Normalise to a single client object; if it's an array, take the row whose id
//             // matches (fallback to the first element).
//             let client: any = null;
//             if (Array.isArray(data)) {
//               const idKey = clientId.toString().toLowerCase();
//               client = data.find(c => (c?.clientRegistrationUId || '').toString().toLowerCase() === idKey)
//                 || data[0] || null;
//             } else {
//               client = data || null;
//             }

//             this.storeSessionAndRoute(user, clientId, client);
//           },
//           error: () => {
//             // Lookup failed (token/interceptor issue) — still let them in with the id we have.
//             this.storeSessionAndRoute(user, clientId, null);
//           }
//         });
//       },
//       error: (err: HttpErrorResponse) => {
//         this.submitted = false;
//         switch (err.status) {
//           case 401:
//             if (err.error?.code === 'REQUIRES_2FA') {
//               this.router.navigate(['/verify-otp'], { queryParams: { challenge: err.error.challengeToken } });
//               return;
//             }
//             this.errorMessage = 'Invalid username or password.';
//             break;
//           case 403:
//             this.errorMessage = 'Please verify your email before signing in.';
//             break;
//           case 423:
//             this.errorMessage = 'Account temporarily locked. Please try again later.';
//             break;
//           default:
//             this.errorMessage = 'Sign in failed. Please try again.';
//         }
//       }
//     });
//   }

//   private storeSessionAndRoute(user: any, clientId: any, client: any | null): void {
//     const companyName = client?.companyName ?? null;
//     const logo = client?.logo ?? null;
//     const productId = user.productUId ?? client?.productUId ?? null;

//     // currentUser is the USER object with branding merged in — NOT the raw array/response.
//     const sessionUser = {
//       ...user,
//       clientRegistrationUId: clientId,
//       productUId: productId,
//       companyName,
//       logo
//     };

//     this.setUserInStorage(sessionUser);
//     if (client) { this.setClientInStorage(client); }        // full ClientRegistration row
//     this.setCurrentClientUId(clientId);
//     if (productId) { this.setCurrentProductUId(productId); }
//     if (companyName) { localStorage.setItem('CompanyName', companyName); }
//     if (logo) { localStorage.setItem('CompanyLogo', logo); }
//     if (user.email) { this.setCurrentEmailId(user.email); }

//     console.log('[login] clientId=', clientId, ' companyName=', companyName);  // remove once verified

//     this.router.navigateByUrl(this.returnUrl);
//   }

//   // ---- storage helpers ----
//   setUserInStorage(user: any) {
//     localStorage.setItem('user', JSON.stringify(user));
//     localStorage.setItem('currentUser', JSON.stringify(user));
//   }
//   setClientInStorage(client: any) { localStorage.setItem('currentClient', JSON.stringify(client)); }
//   setProductInStorage(product: any) { localStorage.setItem('currentProduct', JSON.stringify(product)); }
//   setCurrentProductUId(v: any) { localStorage.setItem('CurrentProductUId', v); }
//   setCurrentClientUId(v: any) { localStorage.setItem('CurrentClientUId', v); }
//   setCurrentRoleBasedlogedin(v: any) { localStorage.setItem('CurrentRoleBasedlogedin', v); }
//   setCurrentloggedinUId(v: any) { localStorage.setItem('CurrentloggedInUId', v); }
//   setCurrentDeviceID(v: any) { localStorage.setItem('CurrentDeviceID', v); }
//   setCurrentEmailId(v: any) { localStorage.setItem('EmailId', v); }

//   addCheckbox(event: Event): void {
//     const current = !!this.loginForm.get('rememberMe')?.value;
//     this.loginForm.get('rememberMe')?.setValue(!current);
//     const box = (event.currentTarget as HTMLElement) || document.getElementById('icheckbox');
//     if (box) { box.classList.toggle('checked', !current); }
//   }
// }





// import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { AuthService } from '../_services/auth.service';
// import { AlertService } from '../_services/alert.service';
// import { HttpErrorResponse } from '@angular/common/http';
// import { AccountService } from '../_services/domainservice/account.service'
// import { SharedComponent } from '../../shared/shared.component';
// import { Injectable } from '@angular/core';
// import { ClientRegistration } from '../model/client.model';
// import { ProductService } from '../_services/domainservice/product.service'
// import { Account } from '../model/account.model';
// import { MenuService } from '../_services/domainservice/menu.service';
// import { Guid } from '../_helpers/guid';
// import { AttendanceDeviceService } from '../_services/domainservice/attendancedevice.service';
// import { AttendanceDevice } from '../model/attendancedevice.model';


// @Component({
//   templateUrl: 'login.component.html',
//   styleUrls: ['./login.component.css']
// })
// export class LoginComponent extends SharedComponent implements OnInit {
//   loginForm: FormGroup;
//   loading = false;
//   submitted = false;
//   returnUrl: string;
//   isPageLoaded = false;
//   client: ClientRegistration = new ClientRegistration;
//   clientRegistrationUId: string;
//   Devicelist: Array<AttendanceDevice>;
//   DeviceNamelist: string;
//   constructor(
//     private accountService: AccountService,
//     private formBuilder: FormBuilder,
//     private route: ActivatedRoute,
//     private router: Router,
//     private alertService: AlertService,
//     public authService: AuthService,
//     private renderer: Renderer2,
//     private productService: ProductService,
//     readonly menuService: MenuService,
//     private attendancedeviceService: AttendanceDeviceService

//   ) {
//     super();
//     this.route.queryParams.subscribe(params => {
//       this.returnUrl = params['returnUrl'];
//     });

//   }

//   ngOnInit() {

//     //email: ['john@pixinvent.com', Validators.required],
//     //  password: ['password@123', Validators.required],
//     //email: ['ganapathy@abgtechnologys.com', Validators.required],
//     //password: ['ganbapathym110#', Validators.required],
//     this.loginForm = this.formBuilder.group({
//       email: ['', Validators.required],
//       password: ['', Validators.required],
//       rememberMe: false
//     });
//     // Remember Me
//     if (localStorage.getItem('remember')) {
//       this.renderer.removeClass(document.body, 'bg-full-screen-image');
//       localStorage.removeItem('currentLayoutStyle');
//       //this.router.navigate(['/dashboard/gym']);
//     } else if (localStorage.getItem('currentUser')) {
//       // Force logout on login if not remember me
//       this.authService.doLogout();
//       this.isPageLoaded = true;
//     } else {
//       this.isPageLoaded = true;
//     }
//   }

//   // convenience getter for easy access to form fields
//   get f() {
//     return this.loginForm.controls;
//   }

//   getpasswordpage() {
//     this.router.navigate(['/login/forgotpassword']);
//   }

//   tryLogin() {
//     this.submitted = true;

//     // stop here if form is invalid
//     if (this.loginForm.invalid) {
//       return;
//     }
//     const value = {
//       email: this.f.email.value,
//       password: this.f.password.value
//     };

//     this.accountService.getAccountLogin(this.getBase64Encode(value.email), this.getBase64Encode(value.password)).subscribe((data): void => {
//       // this.appservice.spinner.next(false);
//       if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
//         localStorage.setItem('remember', 'true');
//       } else {
//         localStorage.removeItem('remember');
//       }
//       this.setUserInStorage(data);
//       this.setCurrentClientUId(data['clientRegistrationUId']);
//       this.setCurrentRoleBasedlogedin(data['roleBasedLogedin'] ? data['roleBasedLogedin'] : Guid.empty);
//       this.setCurrentloggedinUId(data['loggedInUId']);
//       this.setCurrentEmailId(data['mobileNumber']);


//       this.productService.getProduct(data['clientRegistration'].productUId).subscribe((product): void => {
//         this.setProductInStorage(product);
//         this.setCurrentProductUId(product['productUId'])
//         //if (JSON.parse(localStorage.getItem('currentProduct')).productUId === '00000010-0000-0000-0000-000000000000') {

//         //  this.menuService.getMenu().subscribe((menudata): void => {
//         //    this.setMenuInStorage(menudata);
//         //  },
//         //    (error: HttpErrorResponse): void => {
//         //      console.log(error);
//         //      this.alertService.error(error.message);
//         //    }
//         //  );
//         //} else {
//         this.menuService.getMenuProduct(JSON.parse(localStorage.getItem('currentProduct')).productUId, data['roleBasedLogedin']).subscribe((menudata): void => {
//           //this.setMenuInStorage(menudata);
//           this.menuService.setmenu(menudata);
//           this.redirectLogin(menudata);
//           this.attendancedeviceService.getAttendanceDevice(data['clientRegistrationUId']).subscribe((getdevicedata): void => {
//             this.Devicelist = getdevicedata;
//             this.DeviceNamelist = this.Devicelist.filter(o => o.attendanceDeviceName).map(o => o.attendanceDeviceName).join('|').toString();
//             this.setCurrentDeviceID(this.DeviceNamelist);
//           },
//             (error: HttpErrorResponse): void => {
//               console.log(error);
//               this.alertService.error(error.message);
//             }
//           );
//         },
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//             this.alertService.error(error.message);
//           }
//         );
//         //}
//       },

//         (error: HttpErrorResponse): void => {
//           // console.log(error);
//           // this.appservice.spinner.next(false);
//           this.submitted = false;
//           this.alertService.error(error.message);
//         });



//     },
//       (error: HttpErrorResponse): void => {
//         // console.log(error);
//         // this.appservice.spinner.next(false);
//         this.submitted = false;
//         this.alertService.error(error.error.detail);
//       }
//     );


//     //this.authService.doLogin(value).then(
//     //  res => {
//     //    if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
//     //      localStorage.setItem('remember', 'true');
//     //    } else {
//     //      localStorage.removeItem('remember');
//     //    }
//     //    this.setUserInStorage(res);
//     //    localStorage.removeItem('currentLayoutStyle');
//     //    let returnUrl = '/dashboard/sales';
//     //    if (this.returnUrl) {
//     //      returnUrl = this.returnUrl;
//     //    }
//     //    this.router.navigate([returnUrl]);
//     //  },
//     //  err => {
//     //    this.submitted = false;
//     //    this.alertService.error(err.message);
//     //  }
//     //);
//   }
//   addCheckbox(event) {
//     const toggle = document.getElementById('icheckbox');
//     if (event.currentTarget.className === 'icheckbox_square-blue') {
//       this.renderer.addClass(toggle, 'checked');
//     } else if (event.currentTarget.className === 'icheckbox_square-blue checked') {
//       this.renderer.removeClass(toggle, 'checked');
//     }
//   }
//   setUserInStorage(user) {
//     if (user.name) {
//       localStorage.setItem('currentUser', JSON.stringify(user));
//     } else {
//       localStorage.setItem('currentUser', JSON.stringify(user));
//     }
//   }
//   setProductInStorage(product) {
//     if (product.productUId) {
//       localStorage.setItem('currentProduct', JSON.stringify(product));
//     }
//     else {
//       localStorage.setItem('currentProduct', JSON.stringify(product));
//     }
//   }

//   setCurrentProductUId(CurrentProductUId) {
//     localStorage.setItem('CurrentProductUId', CurrentProductUId);
//   }
//   setCurrentClientUId(CurrentClientUId) {
//     localStorage.setItem('CurrentClientUId', CurrentClientUId);
//   }
//   setCurrentRoleBasedlogedin(CurrentRoleBasedlogedin) {
//     localStorage.setItem('CurrentRoleBasedlogedin', CurrentRoleBasedlogedin);
//   }
//   setCurrentloggedinUId(CurrentloggedInUId) {
//     localStorage.setItem('CurrentloggedInUId', CurrentloggedInUId);
//   }
//   setCurrentDeviceID(CurrentDeviceID) {
//     localStorage.setItem('CurrentDeviceID', CurrentDeviceID);
//   }
//   setCurrentEmailId(EmailId) {
//     localStorage.setItem('EmailId', EmailId);
//   }

//   //setMenuInStorage(Menus) {
//   //  localStorage.setItem('currentMenus', JSON.stringify(Menus));
//   //  this.redirectLogin(Menus);
//   //}

//   redirectLogin(UserDetails) {
//     localStorage.removeItem('currentLayoutStyle');
//     UserDetails = UserDetails.sort(function (a, b) {
//       return a.displayOrder - b.displayOrder;
//     });
//     let returnUrl = UserDetails[0].page;// '/dashboard/gym';
//     if (this.returnUrl) {
//       returnUrl = this.returnUrl;
//     }
//     //this.alertService.success("Welcome!");
//     this.router.navigate([returnUrl]);
//   }


// }



import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../_services/domainservice/login.service';
import { ClientService } from '../_services/domainservice/Client.service';
import { environment } from '../../environments/environment';

// Task #45: minimal ambient shape for the Google reCAPTCHA explicit-render API script tag loaded
// in index.html (`<script src=".../api.js?render=explicit">`) — avoids pulling in a full @types
// package for the handful of methods actually used below.
declare const grecaptcha: {
  render: (container: string | HTMLElement, params: { sitekey: string }) => number;
  getResponse: (widgetId?: number) => string;
  reset: (widgetId?: number) => void;
} | undefined;

// Task #55: minimal ambient shapes for the two OAuth SDK script tags loaded in index.html — same
// "just enough of the real @types package to call the handful of methods actually used" approach
// as the grecaptcha declaration above.
declare const google: {
  accounts: {
    id: {
      initialize: (params: { client_id: string; callback: (resp: { credential: string }) => void }) => void;
      renderButton: (container: HTMLElement, params: { theme?: string; size?: string; width?: string; text?: string }) => void;
    };
  };
} | undefined;

declare const msal: {
  PublicClientApplication: new (config: { auth: { clientId: string; authority: string } }) => {
    loginPopup: (request: { scopes: string[] }) => Promise<{ accessToken: string; account?: { username?: string } }>;
  };
} | undefined;

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm!: FormGroup;
  submitted = false;
  isPageLoaded = false;
  errorMessage = '';
  returnUrl = '/dashboard';

  private recaptchaWidgetId: number | null = null;

  // Task #55: Google/Microsoft OAuth login. Both stay false (no button shown) unless the matching
  // environment.*ClientId is configured — same "off until configured" posture as recaptchaSiteKey.
  googleOAuthAvailable = false;
  microsoftOAuthAvailable = false;
  private msalInstance: InstanceType<NonNullable<typeof msal>['PublicClientApplication']> | null = null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly accountService: LoginService,
    private readonly clientService: ClientService,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      // FIXED (Login-Test-Report.md Issue #8): field is an email address (Login.html's own
      // AuthController.cs LoginRequest.Email), not a free-form username, but had no email-format
      // validation — Validators.email added so obviously-malformed input is caught client-side
      // instead of round-tripping to the backend for a generic invalid-credentials response.
      email: ['', [Validators.required,  Validators.pattern(
        /^(?:[0-9]{10}|[^\s@]+@[^\s@]+\.[^\s@]+)$/
      )]],
      password: ['', Validators.required],
      rememberMe: [false]
    });
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
    this.isPageLoaded = true;

    // Task #45: only mount the widget once a real site key is configured — matches the backend's
    // "off until configured" posture (CaptchaOptions.Enabled defaults false), so a fresh clone with
    // no Google credentials yet renders no widget and simply sends captchaToken=null.
    if (environment.recaptchaSiteKey) {
      // grecaptcha.render needs the target element to already be in the DOM; the *ngIf="isPageLoaded"
      // wrapper around Login.html's whole card means it just became true above, so defer one tick.
      setTimeout(() => this.renderCaptcha(), 0);
    }

    // Task #55: same deferred-render reasoning as the reCAPTCHA widget above — the target div only
    // exists once isPageLoaded flips true.
    if (environment.googleOAuthClientId) {
      this.googleOAuthAvailable = true;
      setTimeout(() => this.renderGoogleButton(), 0);
    }
    if (environment.microsoftOAuthClientId) {
      this.microsoftOAuthAvailable = true;
      this.initMicrosoft();
    }
  }

  private renderGoogleButton(): void {
    if (typeof google === 'undefined') { return; }
    const container = document.getElementById('google-signin-button');
    if (!container) { return; }
    google!.accounts.id.initialize({
      client_id: environment.googleOAuthClientId,
      // Bound via an arrow function (not a plain method reference) so `this` still refers to the
      // component instance when Google's SDK invokes it asynchronously, outside Angular's zone.
      callback: (resp) => this.handleGoogleCredential(resp.credential),
    });
    google!.accounts.id.renderButton(container, { theme: 'outline', size: 'large', width: '100%', text: 'signin_with' });
  }

  private initMicrosoft(): void {
    if (typeof msal === 'undefined' || this.msalInstance) { return; }
    this.msalInstance = new msal!.PublicClientApplication({
      auth: { clientId: environment.microsoftOAuthClientId, authority: environment.microsoftOAuthAuthority },
    });
  }

  /** Google Identity Services callback (see renderGoogleButton above) — `credential` is the signed
   *  Google ID token, forwarded as-is to AuthController's OAuthGoogle action (GoogleOAuthVerifier
   *  verifies it server-side; nothing here trusts the decoded payload for auth decisions, only for
   *  a display/redirect-target fallback if 2FA is required next — see decodeJwtEmail below). */
  handleGoogleCredential(credential: string): void {
    this.errorMessage = '';
    const rememberMe = this.loginForm?.value?.rememberMe ?? false;
    const fallbackEmail = this.decodeJwtEmail(credential);
    this.accountService.loginWithGoogle(credential, rememberMe).subscribe({
      next: (res: any) => this.handleAuthSuccess(res),
      error: (err: HttpErrorResponse) => this.handleAuthError(err, false, fallbackEmail),
    });
  }

  /** "Sign in with Microsoft" button click handler (Login.html) — requests a Graph access token via
   *  an MSAL popup, then forwards it to AuthController's OAuthMicrosoft action (MicrosoftOAuthVerifier
   *  verifies it server-side by calling Graph's own /me endpoint). */
  signInWithMicrosoft(): void {
    this.errorMessage = '';
    if (!this.msalInstance) { return; }
    const rememberMe = this.loginForm?.value?.rememberMe ?? false;
    this.msalInstance.loginPopup({ scopes: ['User.Read'] }).then(
      (result) => {
        this.accountService.loginWithMicrosoft(result.accessToken, rememberMe).subscribe({
          next: (res: any) => this.handleAuthSuccess(res),
          error: (err: HttpErrorResponse) => this.handleAuthError(err, false, result.account?.username ?? null),
        });
      },
      () => {
        // User closed the popup or Microsoft rejected the sign-in — not a backend error, so there is
        // no err.error.code to branch on; a generic message is the honest thing to show here.
        this.errorMessage = 'Microsoft sign-in was cancelled or failed. Please try again.';
      }
    );
  }

  /** Decodes the (already server-verified-on-the-backend) Google ID token's payload purely to read
   *  `email` for the /verify-otp redirect's `target` query param if this account also has 2FA
   *  enabled (see handleAuthError's REQUIRES_2FA branch) — never used for any auth decision here,
   *  the same way tryLogin already has the typed email available for that same redirect. Returns
   *  null (never throws) on any malformed/unexpected token shape. */
  private decodeJwtEmail(jwt: string): string | null {
    try {
      const payload = JSON.parse(atob(jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return typeof payload?.email === 'string' ? payload.email : null;
    } catch {
      return null;
    }
  }

  private renderCaptcha(): void {
    if (typeof grecaptcha === 'undefined' || this.recaptchaWidgetId !== null) { return; }
    const container = document.getElementById('recaptcha-container');
    if (!container) { return; }
    this.recaptchaWidgetId = grecaptcha!.render(container, { sitekey: environment.recaptchaSiteKey });
  }

  get f() { return this.loginForm.controls; }

  tryLogin(): void {
    this.submitted = true;
    this.errorMessage = '';
    console.log('Form value:', this.loginForm.value);
  console.log('Form valid:', this.loginForm.valid);
  console.log('Form errors:', this.loginForm.errors);
    if (this.loginForm.invalid) {
      this.submitted = false;
      return;
    }

    const { email, password, rememberMe } = this.loginForm.value;

    // Task #45: read the solved-challenge response token from the widget (if one was rendered)
    // and send it along; RecaptchaVerifier.VerifyAsync short-circuits to true server-side when
    // Captcha:Enabled=false, so this is a harmless null on a clone with no site key configured.
    const captchaToken = (typeof grecaptcha !== 'undefined' && this.recaptchaWidgetId !== null)
      ? grecaptcha!.getResponse(this.recaptchaWidgetId)
      : null;

    this.accountService.login(email, password, rememberMe, captchaToken).subscribe({
      next: (res: any) => this.handleAuthSuccess(res),
      // Task #45: a solved CAPTCHA response token is single-use — Google rejects it on replay — so
      // any failed PASSWORD login attempt must reset the widget or a retry would silently keep
      // failing captcha verification even with correct credentials the second time. resetCaptcha is
      // true only for this call site — the two OAuth handlers (handleGoogleCredential/
      // signInWithMicrosoft below) never rendered a reCAPTCHA widget, so there is nothing to reset.
      error: (err: HttpErrorResponse) => this.handleAuthError(err, true, email),
    });
  }

  /** Shared success handler for password login (tryLogin) and both OAuth logins
   *  (handleGoogleCredential/signInWithMicrosoft) — AuthController's Login/OAuthGoogle/OAuthMicrosoft
   *  actions all return the identical TokenResponse shape on success, so post-login routing
   *  (forced-password-change / onboarding / normal dashboard) doesn't need to know which factor the
   *  user actually signed in with. */
  private handleAuthSuccess(res: any): void {
    if (res?.accessToken) {
      localStorage.setItem('accessToken', res.accessToken);
      localStorage.setItem('token', res.accessToken);
      localStorage.setItem('refreshToken', res.refreshToken || '');
    }
    console.log('========== LOGIN RESPONSE ==========');
    console.log(JSON.stringify(res, null, 2));
    console.log('USER OBJECT:', res?.user);
    console.log('FULL NAME:', res?.user?.fullName);
    const user = res?.user || {};
    this.submitted = false;

    // Task #46: a forced-password-change user (freshly-invited employee whose admin set a
    // temp password, or any account flagged server-side via dbo.Users.MustChangePassword)
    // must land on ChangePasswordRequiredComponent before anything else — they already have
    // real tokens (this IS a successful login), so storage is set as usual, but we short-
    // circuit both the onboarding and the normal dashboard route.
    if (user.mustChangePassword) {
      this.setUserInStorage(user);
      this.router.navigate(['/change-password-required']);
      return;
    }

    const clientId = user.clientRegistrationUId || null;

    // No tenant on the account yet -> onboarding.
    if (!clientId) {
      this.setUserInStorage(user);
      this.router.navigate(['/clientinfo']);
      return;
    }

    // Load this tenant's ClientRegistration record.
    this.clientService.getClient(clientId.toString()).subscribe({
      next: (data: any) => {
        // *** KEY FIX ***  getClient may return a single object OR an array with one row.
        // Normalise to a single client object; if it's an array, take the row whose id
        // matches (fallback to the first element).
        let client: any = null;
        if (Array.isArray(data)) {
          const idKey = clientId.toString().toLowerCase();
          client = data.find(c => (c?.clientRegistrationUId || '').toString().toLowerCase() === idKey)
            || data[0] || null;
        } else {
          client = data || null;
        }

        this.storeSessionAndRoute(user, clientId, client);
      },
      error: () => {
        // Lookup failed (token/interceptor issue) — still let them in with the id we have.
        this.storeSessionAndRoute(user, clientId, null);
      }
    });
  }

  /** Shared error handler for password login and both OAuth logins. `resetCaptcha` only applies to
   *  the password path (see tryLogin's call site above); `fallbackTarget` is the email to forward to
   *  /verify-otp if the account also has 2FA enabled — tryLogin already has the typed email at hand,
   *  the OAuth handlers pass the provider-asserted email instead (see decodeJwtEmail /
   *  signInWithMicrosoft's `result.account?.username`). */
  private handleAuthError(err: HttpErrorResponse, resetCaptcha: boolean, fallbackTarget: string | null): void {
    this.submitted = false;

    if (resetCaptcha && typeof grecaptcha !== 'undefined' && this.recaptchaWidgetId !== null) {
      grecaptcha!.reset(this.recaptchaWidgetId);
    }

    // FIXED (Login-Test-Report.md Issue #4/#5/#6): branch on AuthController's own `code` field
    // first, not just `err.status` — several distinct outcomes share a status code (403 covers
    // both EMAIL_NOT_VERIFIED, TENANT_INACTIVE and PRODUCT_DISABLED; see AuthController.cs's
    // Login action), so a status-only switch collapsed them into the wrong message, and 402
    // (SUBSCRIPTION_INACTIVE) wasn't handled at all before (it fell through to the generic
    // "Sign in failed" default).
    const code = err.error?.code;

    if (code === 'REQUIRES_2FA') {
      // VerifyOtpComponent calls LoginService.verifyOtp(target, code), which hits the real
      // target/code-based ABGTechnologysAccountsController.VerifyOtp endpoint — there is no
      // confirmed backend action that consumes `challengeToken` to finish an authenticated
      // session (see login.service.ts's verifyOtp header comment), so `target` is passed through
      // here too; `challenge` is kept only for display/potential future use, not because anything
      // currently reads it server-side.
      this.router.navigate(['/verify-otp'], { queryParams: { target: fallbackTarget, challenge: err.error.challengeToken } });
      return;
    }

    switch (code) {
      case 'CAPTCHA_FAILED':
        this.errorMessage = 'Please complete the CAPTCHA challenge and try again.';
        return;
      case 'EMAIL_NOT_VERIFIED':
        this.errorMessage = 'Please verify your email before signing in.';
        return;
      case 'TENANT_INACTIVE':
        this.errorMessage = "Your organization's registration is not active. Please contact your administrator.";
        return;
      case 'PRODUCT_DISABLED':
        this.errorMessage = 'This product is not enabled for your organization. Please contact your administrator.';
        return;
      case 'SUBSCRIPTION_INACTIVE':
        this.errorMessage = 'Your subscription is inactive or has expired. Please renew to continue.';
        return;
      // Task #54 follow-up: ProductLicense gate — see AuthController.cs's MapLoginResult switch /
      // LoginOutcome.LicenseInvalid/LicenseExpired remarks.
      case 'LICENSE_INVALID':
        this.errorMessage = 'Your product license is not active. Please contact your administrator.';
        return;
      case 'LICENSE_EXPIRED':
        this.errorMessage = 'Your product license has expired. Please contact your administrator.';
        return;
      // Task #55: OAuth-specific outcomes — see AuthController.cs's MapLoginResult switch.
      case 'NO_ACCOUNT_LINKED':
        this.errorMessage = 'No account is registered with this email. Please sign up first.';
        return;
      case 'OAUTH_UNAVAILABLE':
        this.errorMessage = 'Sign-in with this provider is not available right now.';
        return;
      default:
        break; // fall through to status-based handling below (no distinguishing code from the backend)
    }

    switch (err.status) {
      case 401:
        this.errorMessage = 'Invalid username or password.';
        break;
      case 423:
        this.errorMessage = 'Account temporarily locked. Please try again later.';
        break;
      case 429:
        // AuthController's [EnableRateLimiting("login")] + Program.cs's RejectionStatusCode = 429
        // reject with no JSON body/code at all — status is the only signal available here.
        this.errorMessage = 'Too many sign-in attempts. Please wait a moment and try again.';
        break;
      case 404:
        this.errorMessage = this.errorMessage || 'Account not found.';
        break;
      default:
        this.errorMessage = 'Sign in failed. Please try again.';
    }
  }

  private storeSessionAndRoute(user: any, clientId: any, client: any | null): void {
    const companyName = client?.companyName ?? null;
    const logo = client?.logo ?? null;
    const productId = user.productUId ?? client?.productUId ?? null;
    const name = user.fullName;

    console.log('FULL NAME FROM LOGIN:', user.fullName);
    console.log('NAME VARIABLE:', name);

    // currentUser is the USER object with branding merged in — NOT the raw array/response.
    const sessionUser = {
      ...user,
      clientRegistrationUId: clientId,
      productUId: productId,
      companyName,
      logo,
      name
    };

    this.setUserInStorage(sessionUser);
    if (client) { this.setClientInStorage(client); }        // full ClientRegistration row
    this.setCurrentClientUId(clientId);
    if (productId) { this.setCurrentProductUId(productId); }
    if (companyName) { localStorage.setItem('CompanyName', companyName); }
    if (logo) { localStorage.setItem('CompanyLogo', logo); }
    //if (name) { localStorage.setItem('UserName', name); }
    if (user.email) { this.setCurrentEmailId(user.email); }
    if (user.userGroupUgid) { this.setCurrentRoleBasedlogedin(user.userGroupUgid); }
    if (user.userId) { this.setCurrentloggedinUId(user.userId); }

    // NEW (Task #50 — grace-period post-expiry access): AuthService.IssueTokensAsync now stamps
    // InGracePeriod/GraceEndsUtc onto UserInfo whenever SubscriptionQueryService's grace-window
    // check let an otherwise-expired subscription's login through. Stash GraceEndsUtc so
    // SubscriptionRenewalComponent (which has nothing else it can read TokenResponse.User off of)
    // can show the countdown, per that component's own header comment.
    if (user.inGracePeriod && user.graceEndsUtc) {
      localStorage.setItem('GraceEndsUtc', user.graceEndsUtc);
    } else {
      localStorage.removeItem('GraceEndsUtc');
    }

    // FIXED (Login-Test-Report.md Issue #9): leftover debug console.log removed — it's the kind of
    // thing that shouldn't reach a browser console in production, and its own comment ("remove once
    // verified") confirms it was never meant to stay.

    // NEW (Task #50): nudge grace-period users at /subscription-renewal instead of straight to
    // their normal returnUrl/dashboard — see that component's header comment for why this is a
    // nudge, not a lockout.
    this.router.navigateByUrl(user.inGracePeriod ? '/subscription-renewal' : this.returnUrl);
  }

  // ---- storage helpers ----
  setUserInStorage(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('currentUser', JSON.stringify(user));
  }
  setClientInStorage(client: any) { localStorage.setItem('currentClient', JSON.stringify(client)); }
  setProductInStorage(product: any) { localStorage.setItem('currentProduct', JSON.stringify(product)); }
  setCurrentProductUId(v: any) { localStorage.setItem('CurrentProductUId', v); }
  setCurrentClientUId(v: any) { localStorage.setItem('CurrentClientUId', v); }
  setCurrentRoleBasedlogedin(v: any) { localStorage.setItem('CurrentRoleBasedlogedin', v); }
  setCurrentloggedinUId(v: any) { localStorage.setItem('CurrentloggedInUId', v); }
  setCurrentDeviceID(v: any) { localStorage.setItem('CurrentDeviceID', v); }
  setCurrentEmailId(v: any) { localStorage.setItem('EmailId', v); }

  // FIXED (Login-Test-Report.md Issue #10): the real `#remember-me` checkbox input sits (invisibly,
  // opacity: 0) on top of this whole `#icheckbox` div and receives clicks itself, so its own native
  // `change` event already updates `rememberMe`'s FormControl exactly once via formControlName.
  // The old version ALSO called `setValue(!current)` here unconditionally, so a single click on the
  // input toggled the value twice — once via the native change event, once via this handler —
  // cancelling out and making the checkbox look unresponsive (or responsive only every other click,
  // depending on event timing). Now this handler only forwards a click to the real input when the
  // click landed somewhere else in the div (e.g. its padding, not the input itself), so the
  // FormControl only ever gets toggled once per interaction; the `.checked` visual state in
  // Login.html is bound directly to `f.rememberMe.value` instead of being toggled here by hand.
  addCheckbox(event: Event): void {
    const input = document.getElementById('remember-me') as HTMLInputElement | null;
    if (input && event.target !== input) {
      input.click();
    }
  }
}


